import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmail, setFRedirectUserToEmailAlreadyVerifiedEmailPage, setFRedirectToHomeAfterVerification } from "../../../Slices/sessionSlice";
import Loading from "../../../components/Loading/Loading";

const VerifyEmail = () => {
  // State and hooks setup
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sessionUser, error, fRedirectUserToEmailAlreadyVerifiedPage, fRedirectToHomeAfterVerification, isLoading } = useSelector(
    (state) => state.sessionSlice
  );
  const hasDispatchedVerification = useRef(false);

  // Effect hook for handling already verified email
  useEffect(() => {
    if (fRedirectUserToEmailAlreadyVerifiedPage) {
      dispatch(setFRedirectUserToEmailAlreadyVerifiedEmailPage(false));
      navigate("/email-already-verified");
    }
  }, [fRedirectUserToEmailAlreadyVerifiedPage, dispatch, navigate]);

  // Effect hook for handling successful email verification - redirect to home
  useEffect(() => {
    if (fRedirectToHomeAfterVerification) {
      dispatch(setFRedirectToHomeAfterVerification(false));
      navigate("/");
    }
  }, [fRedirectToHomeAfterVerification, dispatch, navigate]);

  // Effect hook for email verification
  useEffect(() => {
    // Wait for getSession() to complete before proceeding
    if (isLoading) {
      return;
    }

    const vt = searchParams.get("vt");
    const email = searchParams.get("email");

    // If user is already logged in with roles, redirect to home
    if (sessionUser && sessionUser.roles && sessionUser.roles.length > 0) {
      navigate("/");
      return;
    }

    // Only dispatch verifyEmail if:
    // 1. Session loading is complete (isLoading === false)
    // 2. User is not logged in (sessionUser is null)
    // 3. We haven't already dispatched verification
    if (!hasDispatchedVerification.current && !sessionUser) {
      hasDispatchedVerification.current = true;
      dispatch(verifyEmail({ vt: vt || "", email: email || "" }));
    }
  }, [searchParams, sessionUser, isLoading, dispatch, navigate]);

  // Effect hook for error handling
  useEffect(() => {
    if (error) {
      navigate("/");
    }
  }, [error, navigate]);

  // Render method
  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      minHeight: "90vh",
      marginTop: "96px"
    }}>
      <div style={{ width: "100%", maxWidth: "834px", padding: "0 16px", margin: "0 auto" }}>
        <Loading />
      </div>
    </div>
  );
};

export default VerifyEmail;

